import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RmmService } from 'mbs-ui-shared@services/rmm.service';
import { ComputerAppsModule } from '../computer-apps/computer-apps.module';

@NgModule({
  declarations: [],
  imports: [CommonModule, ComputerAppsModule],
  providers: [RmmService]
})
export class SummaryComputersModule {}
